import React from "react";

export const CancellationWorkflow: React.FunctionComponent = (props) => {
  return <>Cancellation Workflow</>;
};
